import "./TrustStats.css";
import { FaClock, FaShieldAlt, FaMapMarkedAlt, FaDog } from "react-icons/fa";

export default function TrustStats() {
  const stats = [
    {
      icon: <FaClock className="trust-icon" />,
      metric: "24h/24 • 7j/7",
      title: "Disponibilité continue",
      desc: "Permanence opérationnelle et astreinte d'urgence 365 jours par an.",
    },
    {
      icon: <FaShieldAlt className="trust-icon" />,
      metric: "100% Certifié",
      title: "Agrément CNAPS",
      desc: "Agents qualifiés titulaires de carte professionnelle, SSIAP et SST.",
    },
    {
      icon: <FaMapMarkedAlt className="trust-icon" />,
      metric: "Île-de-France",
      title: "Rayonnement régional",
      desc: "Déploiement rapide sur l'ensemble des départements franciliens (78, 75, 92...).",
    },
    {
      icon: <FaDog className="trust-icon" />,
      metric: "Spécialité Cynophile",
      title: "Binôme d'élite",
      desc: "Agents maîtres-chiens entraînés pour une dissuasion et une réactivité optimales.",
    },
  ];

  return (
    <section className="trust-section">
      <div className="trust-container">
        {stats.map((item, index) => (
          <div key={index} className="trust-card">
            <div className="trust-icon-box">{item.icon}</div>
            <div className="trust-metric">{item.metric}</div>
            <h3 className="trust-title">{item.title}</h3>
            <p className="trust-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
